import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api, { unwrap } from '../utils/api';

export default function Categories() {
  const [cats, setCats] = useState([]);

  async function load() {
    const r = await api.get('/categories/GetCategoriesAndSubCategoriesSimple');
    setCats(unwrap(r) || []);
  }
  useEffect(() => { load(); }, []);

  async function remove(_id) {
    if (!window.confirm('Delete?')) return;
    await api.post('/categories/DeleteCategory', { _id });
    load();
  }

  return (
    <>
      <h1>Categories</h1>
      <div className="card">
        <Link className="btn" to="/pages/createCategory">+ New Category</Link>
      </div>
      <div className="card">
        <table className="table">
          <thead><tr><th>Name</th><th>Slug</th><th>Parent</th><th>Order</th><th></th></tr></thead>
          <tbody>
            {cats.map(c => (
              <tr key={c._id}>
                <td>{c.name}</td>
                <td>{c.friendlyUrlName}</td>
                <td>{c.parentCategoryId || '—'}</td>
                <td>{c.orderIndex}</td>
                <td>
                  <Link className="btn small secondary" to={`/pages/editCategory/${c._id}`}>Edit</Link>{' '}
                  <button className="btn small danger" onClick={() => remove(c._id)}>Del</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
